import { render } from "./UserOverviewSummaryCards.vue?vue&type=template&id=85b140de&scoped=true"
import script from "./UserOverviewSummaryCards.vue?vue&type=script&lang=js"
export * from "./UserOverviewSummaryCards.vue?vue&type=script&lang=js"

import "./UserOverviewSummaryCards.vue?vue&type=style&index=0&id=85b140de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b140de"],['__file',"src/components/UserOverviewSummaryCards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85b140de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85b140de', __exports__)) {
    api.reload('85b140de', __exports__)
  }
  
  module.hot.accept("./UserOverviewSummaryCards.vue?vue&type=template&id=85b140de&scoped=true", () => {
    api.rerender('85b140de', render)
  })

}


export default __exports__